import React from 'react';
import {Container, Typography, Button, Grid, Card, CardMedia, CardContent, Box, Fab} from '@mui/material';
import Skills from "../Skills";
import Footer from "../Footer";
import About from "../About";
import {Parallax} from "react-parallax";
import "./Portfolio.css"
import {ArrowUpward} from "@mui/icons-material";
import PlaneBackgroundImage from "../../assets/img/planebgc.jpg";
import WebImage from "../../assets/img/web.jpg";
import StoreImage from "../../assets/img/store.jpg";
import CooperationImage from "../../assets/img/cooperation.jpg";
import Team from "../Team";
import Offer from "../Offer";
import {changeLanguage} from "i18next";
import {WithTranslation, withTranslation} from "react-i18next";
import QuoteForm from "../QuoteForm";

interface PortfolioProps extends WithTranslation {}

class Portfolio extends React.Component<PortfolioProps> {
    private changeLanguage = (language: string): void => {
        this.props.i18n.changeLanguage(language);
    };

    state = {
        showScrollTopArrow: false
    };

    private handleScroll = (): void => {
        if (window.scrollY > 300) {
            this.setState({ showScrollTopArrow: true });
        } else {
            this.setState({ showScrollTopArrow: false });
        }
    }

    private scrollToTop = (): void => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    private scrollToComponent = (componentId: string): void => {
        const element: HTMLElement | null = document.getElementById(componentId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }

    componentDidMount(): void {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount(): void {
        window.removeEventListener('scroll', this.handleScroll);
    }

    render(): JSX.Element {
        const { t } = this.props;
        return (
            <>
            <Parallax bgImage={PlaneBackgroundImage} strength={500}>
            <Box style={{ padding: '50px 0', color: '#E0E0E0', textAlign: 'center' }}>

                <div style={{ position: 'relative' }}>
                    <img
                        src="https://cdn.discordapp.com/attachments/917396643609976862/1165341038118977626/two.png?ex=65467f6a&is=65340a6a&hm=c1db16813ba90dbcf1cbe059139c8e528b5b10e91b5afd58bad1c256d83fa3dc&"
                        alt="logo"
                        style={{ maxWidth: '100%', height: 'auto' }}
                    />

                    <Box style={{ position: 'absolute', top: '10px', right: '10px' }}>
                        <Button
                            variant="outlined"
                            color="error"
                            style={{ marginRight: '10px' }}
                            onClick={() => changeLanguage('pl')}
                        >
                            PL
                        </Button>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => changeLanguage('en')}
                        >
                            EN
                        </Button>
                    </Box>
                </div>

                <Container>
                    <Typography variant="subtitle1" paragraph>
                        {t('welcomeMessage')}
                    </Typography>
                </Container>


                <Button variant="contained" color="primary" onClick={() => this.scrollToComponent('offer')}>
                    {t('offer')}
                </Button>

                <Container style={{ padding: '40px 0' }}>
                    <Grid container spacing={4} style={{ marginTop: '40px', alignItems: 'center', justifyContent: 'center' }}>

                        <Grid item xs={12} md={3}>
                            <Card sx={{
                                ':hover': {
                                    boxShadow: '0px 4px 20px white',
                                },
                            }}>
                                <CardMedia
                                    component="img"
                                    height="140"
                                    image={StoreImage}
                                />
                                <CardContent>
                                    <Typography variant="h6">E-commerce</Typography>
                                </CardContent>
                                <Button fullWidth variant="contained" color="primary" onClick={() => this.scrollToComponent('offer')}>
                                    {t('redMoreBtn')}
                                </Button>
                            </Card>
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <Card sx={{
                                ':hover': {
                                    boxShadow: '0px 4px 20px white',
                                },
                            }}>
                                <CardMedia
                                    component="img"
                                    height="140"
                                    image={WebImage}
                                />
                                <CardContent>
                                    <Typography variant="h6">{t('webServices')}</Typography>
                                </CardContent>
                                <Button fullWidth variant="contained" color="primary" onClick={() => this.scrollToComponent('offer')}>
                                    {t('redMoreBtn')}
                                </Button>
                            </Card>
                        </Grid>

                        <Grid item xs={12} md={3} >
                            <Card sx={{
                                ':hover': {
                                    boxShadow: '0px 4px 20px white',
                                },
                            }}>
                                <CardMedia
                                    component="img"
                                    height="140"
                                    image={CooperationImage}
                                />
                                <CardContent>
                                    <Typography variant="h6">{t('cooperation')}</Typography>
                                </CardContent>
                                <Button fullWidth variant="contained" color="primary" onClick={() => this.scrollToComponent('offer')}>
                                    {t('redMoreBtn')}
                                </Button>
                            </Card>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
            </Parallax>
        <About />
        <Skills />
        <Offer />
        <Team />
        <QuoteForm />
        <Footer />
                {this.state.showScrollTopArrow && (
                    <Fab color="secondary" style={{ position: 'fixed', bottom: '30px', right: '30px' }} onClick={this.scrollToTop}>
                        <ArrowUpward />
                    </Fab>
                )}
        </>
    );
    }
}

export default withTranslation()(Portfolio);
